import { Component } from "react";
import { PrimaryButton, QuantitySelector, SecondaryButtonLink, extract } from "@parksandresorts/core";
import styles from "./upgrade-product.module.less";
import UiBkgImage from "@rnb/ui-bkg-image";

export default class UpgradeProduct extends Component {
  constructor(props) {
    super(props);

    this.upgradeFrom = extract(props, "info.upgradeFrom");
    this.upgradeTo = extract(props, "info.upgradeTo");
    this.initialQuantity = extract(props, "info.quantity");
    this.componentTheme = extract(this.upgradeTo, "componentTheme");

    this.state = {
      quantity: this.initialQuantity ? this.initialQuantity : 1,
      productIsUpgraded: false,
      isAddingToCart: false,
    };
  }

  upgradeProduct() {
    //remove old item
    //add same amount of new item
    this.setState({ productIsUpgraded: true });
  }

  render() {
    return (
      <div className={[styles.wrapper, this.componentTheme ? `component-theme-${this.componentTheme}` : ""].join(" ")}>
        <div className="block block--max-width">
          <h2 className={styles.heading}>Kom hit hela sommaren istället!</h2>
          <p className={styles.subheading}>Uppgradera entrén till ett Grönt kort så får du fri entré hela sommaren.</p>
          <UiBkgImage
            className={styles.image}
            imageUrlForSmallDevice={this.productImage}
            imageUrlForLargeDevice={this.productImage}
            smallDeviceImageMaxWidth={1200}
            largeDeviceImageMaxWidth={2560}
          />
          <h4 className={styles.productName}>Gröna Kortet</h4>
          <p className={styles.differenceInPrice}>+ 170 kr/st</p>
          <QuantitySelector
            quantity={this.state.quantity}
            minQuantity={1}
            maxQuantity={9999}
            wrapperClassName={styles.quantityWrapper}
            classNameLeftButton={styles.quantityLeftBtn}
            classNameRightButton={styles.quantityRightBtn}
            quantityClassName={styles.quantityQty}
            onQuantityChanged={(newQuantity) => this.setState({ quantity: newQuantity })}
          />

          <div className={styles.buttonWrapper}>
            <PrimaryButton
              isFullWidth
              label="Uppgradera + 340 kr"
              className={["waves-effect", styles.upgradeButton].join(" ")}
              onClick={this.upgradeProduct}
              isDisabled={this.state.isAddingToCart}
            />

            <SecondaryButtonLink
              label="Fortsätt utan att uppgradera"
              className={["waves-effect", styles.continueButton].join(" ")}
              url="/"
              isFullWidth
              isDisabled={this.state.isAddingToCart}
            />
          </div>
        </div>
      </div>
    );
  }
}
